var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30815 15.2096C2.40815 16.9263 3.33315 18.3346 5.63315 18.3346H14.3665C16.6665 18.3346 17.5831 16.9263 17.6915 15.2096L18.1248 8.3263C18.2415 6.5263 16.8081 5.0013 14.9998 5.0013C14.4915 5.0013 14.0248 4.70964 13.7915 4.25964L13.1915 3.0513C12.8081 2.29297 11.8081 1.66797 10.9581 1.66797H9.04981C8.19148 1.66797 7.19148 2.29297 6.80815 3.0513L6.20815 4.25964C5.97481 4.70964 5.50815 5.0013 4.99981 5.0013C3.19148 5.0013 1.75815 6.5263 1.87481 8.3263L2.09148 11.718",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.66797H11.25",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.9987C11.492 14.9987 12.7087 13.782 12.7087 12.2904C12.7087 10.7987 11.492 9.58203 10.0003 9.58203C8.50866 9.58203 7.29199 10.7987 7.29199 12.2904C7.29199 13.782 8.50866 14.9987 10.0003 14.9987Z",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1cb0e28ef5eead4e75bc4847167e45fe.svg";
export { ForwardRef as ReactComponent };